import{jsxs as p,jsx as o}from"react/jsx-runtime";import s from"styled-components";import d from"../../icons/components/CheckmarkIcon.js";import $ from"../../icons/components/CloseIcon.js";import f from"../Spinner/index.js";import"../../theme.js";import"../../utils/utils.js";const c=s.div`
  position: absolute;
`,h=s(f)`
  position: absolute;

  ${({$size:i})=>`
      width: ${i}rem;
      height: ${i}rem;
      margin-left: -${i/2}rem;
  `}

  border-width: 1px;
  transition:
    all 0.02s ease-in-out !important,
    width transition 0s !important;

  ${({$isLoading:i,theme:r})=>!i&&`
        animation: none;
        border: 1px solid ${r.colors.grayscaleToned.dark3};
    `}
`,n=s.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 1px;
  top: 1px;

  ${({$size:i})=>`
      width: ${i}rem;
      height: ${i}rem;
      margin-left: -${i/2}rem;
      font-size: ${i/2}rem;
  `}
  transition: opacity 500ms ease-in-out;
  opacity: ${({$isDone:i,$isError:r})=>!i&&!r?"0":"1"};
`,l=({isLoading:i=!0,isDone:r=!1,isError:a=!1,size:e=3.5,ariaLabels:t={},...m})=>p(c,{"data-testid":"spinner-thin",role:"status","aria-live":"polite","aria-label":r?t?.isDone??"Completed":a?t?.isError??"Error":t?.isError??"Loading...","aria-busy":i,children:[o(n,{$size:e,$isDone:r,children:o(d,{})}),o(n,{$size:e,$isError:a,children:o($,{})}),o(h,{size:e,speed:"fast",color:"neutral",...m,$size:e,$isLoading:i,useAria:!1})]});export{l as SpinnerThin,l as default};
